module.exports = __webpack_public_path__ + "img/AI_book.e34fe862.jpg";